import { useScrollProgress } from '../../hooks/useScrollProgress';

export default function ScrollProgress() {
  const scrollProgress = useScrollProgress();

  return (
    <div className="fixed top-0 left-0 w-full h-0.5 bg-zinc-200 z-50">
      <div
        className="h-full bg-zinc-900 transition-all duration-150"
        style={{ width: `${scrollProgress}%` }}
      />
    </div>
  );
}
